import { IconUpload } from '@tabler/icons-react';
import { useTranslation } from '../../../../../i18n/hooks/useTranslation';

export default function VideoDropZone({
    title,
    hint,
    isDragging,
    onClick,
    onDragOver,
    onDragLeave,
    onDrop,
    onKeyDown,
    className = '',
    // Every video tool takes a pasted clip, so the line lives here rather than
    // being passed in ten times — it cannot drift out of step with the hook.
    showPasteHint = true,
}) {
    const { t } = useTranslation();
    return (
        <div
            role="button"
            tabIndex={0}
            onClick={onClick}
            onKeyDown={onKeyDown}
            onDragOver={onDragOver}
            onDragLeave={onDragLeave}
            onDrop={onDrop}
            className={`flex w-full cursor-pointer flex-col items-center gap-2 rounded-[14px] border-[1.5px] border-dashed border-violet-400 bg-violet-50 px-4 py-6 transition-colors dark:border-violet-700 dark:bg-violet-900/20 ${
                isDragging ? 'border-primary bg-primary/5' : 'hover:border-violet-500'
            } ${className}`}
        >
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-white text-violet-600 shadow-[0_1px_2px_rgba(28,24,21,0.04)] dark:bg-zinc-900 dark:text-violet-400">
                <IconUpload size={21} stroke={1.8} />
            </div>
            <div className="text-sm font-semibold text-[#1C1815] dark:text-zinc-100">{title}</div>
            {hint ? (
                <div className="text-xs text-[#A8A099] dark:text-zinc-500">{hint}</div>
            ) : null}
            {showPasteHint ? (
                <div className="text-[11px] text-[#A8A099] dark:text-zinc-500">
                    {t('toolPage.pasteHintVideo')}
                </div>
            ) : null}
        </div>
    );
}
